import Vue from 'vue';
import { Component } from 'vue-property-decorator';

const SvgIconProps = Vue.extend({
  props: {
    dynamicValue: {
      type: String,
      required: true,
    },
    classWrapper: {
      type: Object,
    },
    svgType: {
      type: String,
      default: 'icon',
    },
  },
});

const convertToKebabCase = (string) => {
  return string.replace(/\s+/g, '-').toLowerCase();
};

@Component({})
export default class SvgIcon extends SvgIconProps {
  get getSvgType() {
    return this.svgType;
  }

  get getClasses() {
    return this.classWrapper;
  }

  iconPath(dynamicValue) {
    const value = convertToKebabCase(dynamicValue);
    const icon = require(`@/assets/icons/${value}.svg?inline`);
    return icon;
  }
}
